import React, { useContext, useState } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import DashboardContext from '#/context';
import styles from './styles.module.css';

import {useTabs} from '#/contexts/tabscontexts';

import { useTranslation } from "react-i18next";
import FloatingTooltipSticky from '#/components/FloatingTooltipSticky/index';


function Tabs() {
  const {
    activeDashboard,
    tempDashboard,
    setTempDashboard,
    stateDashboard,
  } = useContext(DashboardContext);

  const {activeTabIndex, setActiveTabIndex, handleNewTab} = useTabs();

  const [readOnly, setReadOnly] = useState(true);
  const [draggedItem, setDraggedItem] = useState(null);

  const { t } = useTranslation();


  async function handleClose(e) {
    const target = e.target.parentNode;
    const targetOrdination = target.getAttribute('dataKey');
    const newDash = tempDashboard.filter(
      dashItem => targetOrdination !== dashItem.id || tempDashboard.length === 1
    );
    setTempDashboard(
      newDash.map((dashItem, index) => ({
        ...dashItem,
        ordination: ++index,
      }))
    );
    if (!newDash[activeTabIndex]) {
      setActiveTabIndex(newDash.length - 1);
    }
  }

  function handleInput(event, index) {
    tempDashboard[index].name = event.target.value;
    setTempDashboard([...tempDashboard]);
  }

  function handleDoubleClick(e) {
    e.target.select();
    return stateDashboard.edit && setReadOnly(false);
  }

  async function handleRename(e) {
    if (stateDashboard.edit) {
      const allDash = tempDashboard.map(dashItem => {
        if (!dashItem.widgets) return { ...dashItem, widgets: [] };
        return dashItem;
      });
      setTempDashboard(allDash);
    }
    setReadOnly(true);
    e.target.blur();
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      setReadOnly(true);
      e.target.blur();
    }
  }

  function sortDashboard() {
    const currentDashboard = stateDashboard.edit
      ? tempDashboard
      : activeDashboard;
    return currentDashboard.sort(
      (objA, objB) => objA['ordination'] - objB['ordination']
    );
  }

  function sortOrdinationBelow(destination) {
    const newDash = tempDashboard.map(dashItem => {
      if (dashItem.id === draggedItem)
        return { ...dashItem, ordination: destination };
      else if (dashItem.ordination > destination) return { ...dashItem };
      else return { ...dashItem, ordination: --dashItem.ordination };
    });
    setTempDashboard(newDash);
  }
  function sortOrdinationHigher(destination) {
    const newDash = tempDashboard.map(dashItem => {
      if (dashItem.id === draggedItem)
        return { ...dashItem, ordination: destination };
      else if (dashItem.ordination < destination) return { ...dashItem };
      else return { ...dashItem, ordination: ++dashItem.ordination };
    });
    setTempDashboard(newDash);
  }

  async function handleDrop(e) {
    if (e.target.tagName === 'INPUT') {
      e.target = e.target.parentNode;
    }
    const draggedObject = tempDashboard.find(({ id }) => draggedItem === id);
    const targetObject = tempDashboard.find(
      ({ id }) => id === e.target.getAttribute('dataKey')
    );

    if (draggedObject.ordination < targetObject.ordination) {
      sortOrdinationBelow(targetObject.ordination);
    } else if (draggedObject.ordination > targetObject.ordination) {
      sortOrdinationHigher(targetObject.ordination);
    }
    setActiveTabIndex(tempDashboard.indexOf(targetObject));
  }

  const tabs = sortDashboard().map(({ name, id }, index) => {
    const isActive = index === activeTabIndex;
    return (
      <CSSTransition
        component={null}
        key={id}
        timeout={{
          enter: 200,
          exit: 100,
        }}
        mountOnEnter
        unmountOnExit
        classNames={{
          enter: styles['move-enter'],
          enterActive: styles['move-enter-active'],
          exit: styles['move-exit'],
          exitActive: styles['move-exit-active'],
        }}
      >
        <li
          key={id}
          datakey={id}
          tabIndex={index + 1}
          className={[styles.tab, isActive ? styles.active : ''].join(' ')}
          onDragStart={() => setDraggedItem(id)}
          onDragOver={e => e.preventDefault()}
          onDrop={handleDrop}
          draggable={stateDashboard.edit}
        >
          <FloatingTooltipSticky content={name}>
            <span className={styles.spanEllipsis}>
              <input
                tabIndex="-1"
                className={[
                  styles.dashboardName,
                  stateDashboard.edit ? styles.editable : '',
                ].join(' ')}
                value={name || !readOnly ? name : t('UNTITLED')}
                readOnly={readOnly}
                onClick={() => setActiveTabIndex(index)}
                onChange={e => handleInput(e, index)}
                onDoubleClick={e => handleDoubleClick(e)}
                onBlur={e => handleRename(e, index)}
                onKeyPress={e => handleKeyPress(e)}
              />
            </span>
          </FloatingTooltipSticky>
          {stateDashboard.edit && (
            <button className={styles.closeButton} onClick={handleClose} />
          )}
        </li>
      </CSSTransition>
    );
  });

  return (
    <div className={styles.tabs}>
      <nav>
        <ul className={styles.tabList}>
          <TransitionGroup component={null} enter={true}>
            {tabs}
          </TransitionGroup>
        </ul>
      </nav>
      {stateDashboard.edit && (
        <button className={styles.addButton} onClick={ () => handleNewTab()}>
          +
        </button>
      )}
    </div>
  );
}

export default Tabs;
